export const MuiPaginationItem = (palette) => ({
  textSecondary: {
    '&.Mui-selected': {
      background: palette.common.colors.blue
    }
  }
});
